/**
 * Formats and hides a phone number.
 * Example: '+79999999999' -> +7-(9**)-***-99-99
 */

export const getHiddenPhoneNumber = (phone: string): string => {
  const parts = phone.match(/^\+(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/);

  const [_, p1, p2, , p4, p5] = parts;
  return `${p1}-(${p2[0]}**)-***-${p4}-${p5}`;
};
